/**
 * This is the entry point to review screen.
 * get all workers reporting to the loggedin supervisor.
 * set first as selected.
 * @author: shaurabh.shah.prtnr@ironmountain.com
 *
 * Hierarchy of components:
 * ReviewView
 * --Reportees: list of all workers.
 * --PunchHeader: Add punch & week picker
 * ----WeekPicker
 * --PunchList: API for punches & approve
 * ----SelectPunch
 * ------DayItem
 * --------DayRecords
 *
 */

import React, { useState, useEffect } from "react";
import Alert from "@material-ui/lab/Alert";
// I18n
import { useTranslation } from "react-i18next";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
} from "react-router-dom";
import {
  makeStyles,
  Typography,
  CircularProgress,
  Drawer,
} from "@material-ui/core";

import clsx from "clsx";
import PunchHeader from "./components/PunchHeader";
import ReportHeader from "./components/ReportHeader";
import PunchList from "./components/ReviewList/PunchList";
import ManageWorkers from "./components/ManageWorkers";
import ReportView from "./components/ReportView";
import DrawerFooter from "components/DrawerFooter";
import { ManageActivityGroups } from "./components/ManageActivityGroups";
import { HighDurationAllPunchesView } from "./components/HighDurationAllPunchesView";
import { ManageTimesheet } from "./components/ManageTimesheet";

// import workerData from "DATA/worker";
import { useDispatch, useSelector } from "react-redux";
import { getWorkerPunches, getWorkersByMgr } from "services";
import { startOfWeek } from "date-fns";
import Reportees from "./components/Reportees";
import {
  ACTIVITIES,
  ADD_WORKER,
  ALL_ACTIVITIES,
  INCOMPLETE_PUNCHES,
  MANAGE_ACTIVITY_GROUP,
  MANAGE_WORKERS,
  ALL_HIGH_DURATION_ACTIVITIES,
  REPORTS,
  REVIEW,
  MANAGE_TIMESHEET,
  TRANSPORT_TRIP
} from "navigation/CONSTANTS";
import { isEmptyObject } from "utils/index";
import {
  MY_TEAM,
  TEMP,
  EMPLOYEE,
  MANAGE_FOR_BY_COUNTRY_FOR_REVIEW_VIEW,
} from "config/CONSTANTS";
import AllPunchView from "./components/AllPunchView";
import { selectedWeekOnReview } from "redux/actions/appActions";
import { setAllMyWorkers, setAllWorkersFor } from "redux/actions/workerActions";
import moment from "moment";
import IncompleteView from "./components/IncompleteView";
import { dateConfig } from "config";
import { optionsAvailable } from "pages/AddWorker/components/utils";
import {
  getWorkerIMTimeRole,
} from "services/workerSchedule";
import TransportTripDetails from "./components/TransportTripDetails";
export const ReviewView = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [loadingError, setLoadingError] = useState("");
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  /**
   * on load, perform below actions:
   * 1. get all the workers reporting to the signed in supervisor.
   * 2. set the list of workers and selected worker in context for further use.
   */
  const { user, isLoading: userLoading } = useSelector(
    (state) => state.user.auth
  ); // manager

  const appConfig = useSelector((state) => state.appConfig);
  const { dscDrawerOpen } = appConfig;

  const [updateList, toggleUpdateList] = useState(true); // use this as useEffect dependency to update the list to latest.
  const reloadList = () => {
    toggleUpdateList(!updateList);
  };
  const [allWorkers, setAllWorkers] = useState({}); // workers reporting to manager
  const [allWorkersIds, setAllWorkersIds] = useState([]); // IDs of all workers reporting to manager
  const [allOtherWorkersIds, setAllOtherWorkersIds] = useState([]); // IDs of all workers reporting to manager
  const [allPunches, setAllPunches] = useState({ a: 123 }); // all punches of all workers
  const [allOtherPunches, setAllOtherPunches] = useState({ b: 123 }); // all punches of all workers from other mgr team
  const [selectedWorker, setSelectedWorker] = useState(null); // first worker
  const [highDuration, setHighDuration] = useState(null);
  const [selectedWorkers, setSelectedWorkers] = useState([]);
  const [imtRole, setImtRole] = useState("");
  const {
    isManageWorkers,
    isReportView,
    isAllPunchView,
    isManageActivityGroup,
    isHighDuration,
    isTimesheetView,
    isTransportationDetails
  } = location.state || {};
  const setManageWorkers = () => {
    console.log("setManageWorkers called");
  };
  const setReportView = () => {
    console.log("setReportView called");
  };
  const setAllPunchView = () => {
    console.log("setAllPunchView called");
  };
  const setManageActivityGroup = () => {
    console.log("setManageActivityGroup called");
  };

  const setTimesheetView = () => {
    console.log("setTimesheetView called");
  };
  const setTransportDetails = () =>{
    console.log("setTransportDetails called");
  };

  const { myWorkers, workersFor } = useSelector((state) => state.workers);
  const loggedInUser = useSelector((state) => state.user);
  const loggedInSupervisor = loggedInUser.auth.user.workerId;
  useEffect(() => {
    if (loggedInSupervisor) {
      getWorkerIMTimeRole(loggedInSupervisor).then((data) => {
        setImtRole(data.role);
      });
    }
    setAllWorkers({});
    updateWorkers(myWorkers);
  }, [myWorkers]);
  useEffect(() => {
    updateWorkers(workersFor, true);
  }, [workersFor]);

  const updateWorkers = (data, isForOther) => {
    let workerIds = data
      .map((item) => item.workerId || null)
      .filter((item) => item !== null);
    // console.log(`SS:: workerIds ${isForOther?"For":""}===`,workerIds);
    isForOther ? setAllOtherWorkersIds(workerIds) : setAllWorkersIds(workerIds);
    let workers = { ...allWorkers };
    if (data.length > 0) {
      data = data.sort((a, b) =>
        a.firstName?.toLowerCase() > b.firstName?.toLowerCase()
          ? 1
          : b.firstName?.toLowerCase() > a.firstName?.toLowerCase()
            ? -1
            : 0
      );
      let activeWorkers = data.filter((item) => item.isActiveWorker === true);
      let manageData = data.filter(
        (item) =>
          (item.workerType === EMPLOYEE && item.isActiveWorker === true) ||
          item.workerType === TEMP
      );

      workers[isForOther ? "allOtherTeam" : "all"] = manageData;
      workers[isForOther ? "otherTeam" : "myTeam"] = activeWorkers;
      if (isForOther) {
        workers.otherManagerId = appConfig.selectedManagerForApproval
          ? appConfig.selectedManagerForApproval.managerId
          : null;
      } else {
        workers.managerId = user.workerId;
      }

      if (
        !isManageWorkers &&
        !isReportView &&
        !isAllPunchView
        // && isEmptyObject(selectedManagerForApproval)
      ) {
        setSelectedWorker(data[0]);
      }
      setLoadingError("");
    } else {
      //Error moved to PunchList component
      //setLoadingError("pgReview.noWorkerForManager");
      workers[isForOther ? "allOtherTeam" : "all"] = [];
      workers[isForOther ? "otherTeam" : "myTeam"] = [];
    }
    setAllWorkers(workers);
  };

  const handleEditWorker = (worker) => {
    history.push(ADD_WORKER, { empId: worker.workerId, worker: worker });
  };

  const approveForManager = appConfig.selectedManagerForApproval
    ? appConfig.selectedManagerForApproval
    : null;
  const [selectedManagerForApproval] = useState(approveForManager);
  const team = appConfig.selectedTeamOnReview
    ? appConfig.selectedTeamOnReview.team
    : MY_TEAM;
  const [selectedTeam, setSelectedTeam] = useState(team);

  const getAllPunches = (isOtherMgr) => {
    let initDate =
      (appConfig.selectedWeekOnReview && appConfig.selectedWeekOnReview.week) ||
      new Date();
    let startDate1 = moment(initDate).format(dateConfig.format6);
    let endDate1 = moment(new Date(initDate))
      .add(7, "days")
      .format(dateConfig.format6);
    return getWorkerPunches(
      isOtherMgr ? allOtherWorkersIds : allWorkersIds,
      startDate1,
      endDate1
    ).then((punches) => {
      console.log("getWorkerPunches data=", punches);
      isOtherMgr ? setAllOtherPunches(punches) : setAllPunches(punches);
    });
  };

  const getReporteeDetails = () => {
    const workers = {};
    let isOtherTeamLoading = true;
    if (!isEmptyObject(selectedManagerForApproval)) {
      getWorkersByMgr(selectedManagerForApproval.managerId)
        .then((data) => {
          console.log(
            `getWorkersByMgr for ${selectedManagerForApproval.managerId} = data=`,
            data
          );
          let iApproveForWorkers = data.workers.filter((item) =>
            item?.approvingManager?.includes(user.workerId)
          );
          console.log("tested", iApproveForWorkers);
          console.log("tested all", data.workers);
          // REDUX Set All My Workers
          // dispatch(setAllWorkersFor(iApproveForWorkers))
          //dispatched all workers so that the list in manage for someone else's team shows all the worker's name
          MANAGE_FOR_BY_COUNTRY_FOR_REVIEW_VIEW
            ? dispatch(setAllWorkersFor(data.workers))
            : dispatch(setAllWorkersFor(iApproveForWorkers));

          // setAllOtherWorkersIds(data.workerIds);
          // if (data && data.workers && data.workers.length > 0) {
          //   data.workers = data.workers.sort((a, b) =>
          //     a.firstName.toLowerCase() > b.firstName.toLowerCase()
          //       ? 1
          //       : b.firstName.toLowerCase() > a.firstName.toLowerCase()
          //       ? -1
          //       : 0
          //   );
          //   let activeWorkers = data.workers.filter(
          //     (item) => item.isActiveWorker === true
          //   );
          //   let manageData = data.workers.filter(
          //     (item) =>
          //       (item.workerType === EMPLOYEE &&
          //         item.isActiveWorker === true) ||
          //       item.workerType === TEMP
          //   );
          //   workers.allOtherTeam = manageData;
          //   workers.otherTeam = activeWorkers;
          //   workers.otherManagerId = selectedManagerForApproval.managerId;
          //   setAllWorkers(workers);
          //   if (!isManageWorkers && !isReportView && !isAllPunchView) {
          //     setSelectedWorker(data.workers[0]);
          //   }
          //   setLoadingError("");
          // } else {
          //   //Error moved to PunchList component
          //   //setLoadingError("pgReview.noWorkerForManager");
          // }

          isOtherTeamLoading = false;
        })
        .catch((err) => {
          isOtherTeamLoading = false;
          setLoadingError("pgReview.errLoadingWorkerList");
          console.error("ReviewView: Err in getWorkerByMgr Response: ", err);
        });
    }

    // Get all My Workers
    getWorkersByMgr(user.workerId)
      .then((data) => {
        console.log(`getWorkersByMgr for ${user.workerId} = data=`, data);
        // REDUX Set All My Workers
        dispatch(setAllMyWorkers(data.workers));

        // MOVED IN FUNCTION updateWorkers()
        // setAllWorkersIds(data.workerIds);
        // if (data && data.workers && data.workers.length > 0) {
        //   data.workers = data.workers.sort((a, b) =>
        //     a.firstName.toLowerCase() > b.firstName.toLowerCase()
        //       ? 1
        //       : b.firstName.toLowerCase() > a.firstName.toLowerCase()
        //       ? -1
        //       : 0
        //   );
        //   let activeWorkers = data.workers.filter(
        //     (item) => item.isActiveWorker === true
        //   );
        //   let manageData = data.workers.filter(
        //     (item) =>
        //       (item.workerType === EMPLOYEE && item.isActiveWorker === true) ||
        //       item.workerType === TEMP
        //   );
        //   workers.all = manageData;
        //   workers.myTeam = activeWorkers;
        //   workers.managerId = user.workerId;
        //   setAllWorkers(workers);
        //   if (
        //     !isManageWorkers &&
        //     !isReportView &&
        //     !isAllPunchView &&
        //     isEmptyObject(selectedManagerForApproval)
        //   ) {
        //     setSelectedWorker(data.workers[0]);
        //   }
        //   setLoadingError("");
        // } else {
        //   //Error moved to PunchList component
        //   //setLoadingError("pgReview.noWorkerForManager");
        // }
        if (
          selectedManagerForApproval == null ||
          (!isEmptyObject(selectedManagerForApproval) && !isOtherTeamLoading)
        ) {
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setLoadingError("pgReview.errLoadingWorkerList");
        console.error("ReviewView: Err in getWorkerByMgr Response: ", err);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    setLoadingError("");
    if (userLoading) {
      console.log("Continue loading google user's data from IRM DB!");
    } else if (user.workerId) {
      getReporteeDetails();
    } else {
      setIsLoading(false);
      setLoadingError("pgReview.errLoadingWorkerId");
      console.log(
        "ReviewView: else in getWorkerByMgr condition: No Logged in worker details found!"
      );
    }
    return () => {
      setAllWorkers({});
      setSelectedWorker({});
      setAllWorkersIds([]);
      setAllOtherWorkersIds([]);
    };
  }, [userLoading, updateList]);

  // Update punch count detials in side navigation.
  useEffect(() => {
    getAllPunches(false);
  }, [appConfig.selectedWeekOnReview, allWorkersIds]);
  useEffect(() => {
    getAllPunches(true);
  }, [appConfig.selectedWeekOnReview, allOtherWorkersIds]);

  // week start date for punch records
  const [startDate, setStartDate] = useState(startOfWeek(new Date()));
  const [month, setMonth] = useState(new Date());

  //Monthly/Weekly view Selection
  const [view, setView] = useState(optionsAvailable[0]);

  useEffect(() => {
    if (
      appConfig &&
      appConfig.selectedWorkerOnReview &&
      appConfig.selectedWorkerOnReview.worker
    ) {
      setSelectedWorker(appConfig.selectedWorkerOnReview.worker);
    }
  }, [appConfig, selectedWorker]);

  useEffect(() => {
    if (
      appConfig &&
      appConfig.selectedTeamOnReview &&
      appConfig.selectedTeamOnReview.team
    ) {
      setSelectedTeam(appConfig.selectedTeamOnReview.team);
    }
  }, [selectedTeam]);

  // refer to user selected week on review page in last interaction
  // and set startDate
  useEffect(() => {
    if (!(appConfig && appConfig.selectedWeekOnReview)) {
      var weekStart = startOfWeek(new Date());
      dispatch(selectedWeekOnReview({ week: weekStart }));
      setStartDate(weekStart);
    }
  }, []);
  useEffect(() => {
    if (
      appConfig &&
      appConfig.selectedWeekOnReview &&
      appConfig.selectedWeekOnReview.week
    ) {
      setStartDate(startOfWeek(new Date(appConfig.selectedWeekOnReview.week)));
    }
    if (appConfig && appConfig.selectedMonthOnReport) {
      setMonth(new Date(appConfig.selectedMonthOnReport));
    }
  }, [appConfig.selectedWeekOnReview, appConfig.selectedMonthOnReport]);

  useEffect(() => {
    let delegateFor = user?.delegateFor;
    if ((!(delegateFor && approveForManager &&
      delegateFor.includes(approveForManager.managerId))) && ((imtRole && imtRole !== "" && imtRole.toLowerCase() === "supervisor")
        || (!imtRole && loggedInUser && loggedInUser.auth.user.isApprover))) {
      const selManWorkers = allWorkers && allWorkers.otherTeam &&
        allWorkers.otherTeam.filter(item => item.approvingManager && item.approvingManager.includes(loggedInSupervisor))
      setSelectedWorkers(selManWorkers);
    }
    else {
      setSelectedWorkers(allWorkers.otherTeam);
    }

    console.log(loggedInUser);
  }, [appConfig.selectedManagerForApproval, allWorkers, imtRole])

  const reviewMarkup = (
    <>
      <div className={classes.root}>
        {/* <CssBaseline /> */}
        <Drawer
          variant="permanent"
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: dscDrawerOpen,
            [classes.drawerClose]: !dscDrawerOpen,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: dscDrawerOpen,
              [classes.drawerClose]: !dscDrawerOpen,
            }),
          }}
          PaperProps={{ className: classes.paperStyle }}
        >
          <Reportees
            allWorkers={allWorkers}
            allPunches={allPunches}
            allOtherPunches={allOtherPunches}
            selectedWorker={selectedWorker}
            setSelectedWorker={setSelectedWorker}
            isManageWorkers={isManageWorkers}
            setManageWorkers={setManageWorkers}
            isReportView={isReportView}
            setReportView={setReportView}
            approveForManager={selectedManagerForApproval}
            selectedTeam={selectedTeam}
            setSelectedTeam={setSelectedTeam}
            isAllPunchView={isAllPunchView}
            setAllPunchView={setAllPunchView}
            isManageActivityGroup={isManageActivityGroup}
            setManageActivityGroup={setManageActivityGroup}
            setHighDuration={setHighDuration}
            isHighDuration={isHighDuration}
            isTimesheetView={isTimesheetView}
            setTimesheetView={setTimesheetView}
            isTransportationDetails={isTransportationDetails}
            setTransportDetails = {setTransportDetails}
          />
          <DrawerFooter />
        </Drawer>
        <main className={classes.content}>
          <Switch>
            <Route exact path={REVIEW}>
              <Redirect to={ALL_ACTIVITIES} />
            </Route>
            <Route path={ALL_ACTIVITIES}>
              <>
                <PunchHeader
                  dateHandles={[startDate, setStartDate]}
                  worker={selectedWorker}
                  workers={allWorkers[selectedTeam]}
                  isAllPunchView={isAllPunchView}
                  allPunches={allPunches}
                />
                <AllPunchView
                  weekStartDate={startDate}
                  allWorkers={allWorkers}
                  selectedTeam={selectedTeam}
                />
              </>
            </Route>
            <Route path={ACTIVITIES}>
              <>
                <PunchHeader
                  dateHandles={[startDate, setStartDate]}
                  worker={selectedWorker}
                  isAllPunchView={isAllPunchView}
                />
                <PunchList
                  worker={selectedWorker}
                  weekStartDate={startDate}
                  allWorkers={allWorkers}
                  selectedTeam={selectedTeam}
                />
              </>
            </Route>
            <Route path={MANAGE_WORKERS}>
              <ManageWorkers
                allWorkers={allWorkers}
                handleEditWorker={handleEditWorker}
                reloadList={reloadList}
                selectedTeam={selectedTeam}
                approveForManager={selectedManagerForApproval}
                selectedWorkers={selectedWorkers}
                imtRole={imtRole}
                isLoading={isLoading}
              />
            </Route>
            <Route path={REPORTS}>
              <>
                <ReportHeader
                  dateHandles={[month, setMonth]}
                  weekHandles={[startDate, setStartDate]}
                  optionsAvailable={optionsAvailable}
                  viewHandles={[view, setView]}
                />
                <ReportView month={month} week={startDate} view={view}
                 approveForManager={selectedManagerForApproval}
                 selectedTeam={selectedTeam}
                 imtRole={imtRole}/>
              </>
            </Route>
            <Route path={INCOMPLETE_PUNCHES}>
              <IncompleteView
              approveForManager={selectedManagerForApproval}
              selectedTeam={selectedTeam}
              imtRole={imtRole}
              />
            </Route>
            <Route path={MANAGE_ACTIVITY_GROUP}>
              <ManageActivityGroups />
            </Route>
            <Route path={ALL_HIGH_DURATION_ACTIVITIES}>
              <HighDurationAllPunchesView 
                approveForManager={selectedManagerForApproval}
                selectedTeam={selectedTeam}
                imtRole={imtRole}
              />
            </Route>
            <Route path={MANAGE_TIMESHEET}>
              <ManageTimesheet
                allWorkers={allWorkers}
                approveForManager={selectedManagerForApproval}
                selectedTeam={selectedTeam}
                selectedWorkers={selectedWorkers}
                imtRole={imtRole}
                isLoading={isLoading}
              />
            </Route>
            <Route path={TRANSPORT_TRIP}>
              <>
                <TransportTripDetails 
                 view={view}
                 approveForManager={selectedManagerForApproval}
                 selectedTeam={selectedTeam}
                 imtRole={imtRole}/>
              </>
            </Route>
          </Switch>

          {/* {isManageActivityGroup ? (
            <ManageActivityGroups />
          ) :
          isManageWorkers ? (
            <ManageWorkers
              allWorkers={allWorkers}
              handleEditWorker={handleEditWorker}
              reloadList={reloadList}
              selectedTeam={selectedTeam}
              approveForManager={selectedManagerForApproval}
            />
          ) : isReportView ? (
            <>
              <ReportHeader dateHandles={[month, setMonth]} />
              <ReportView month={month} />
            </>
          ) : isAllPunchView ? (
            <>
              <PunchHeader
                dateHandles={[startDate, setStartDate]}
                worker={selectedWorker}
                workers={allWorkers[selectedTeam]}
                isAllPunchView={isAllPunchView}
              />
              <AllPunchView
                weekStartDate={startDate}
                allWorkers={allWorkers}
                selectedTeam={selectedTeam}
              />
            </>
          ) : (
            <>
              <PunchHeader
                dateHandles={[startDate, setStartDate]}
                worker={selectedWorker}
                isAllPunchView={isAllPunchView}
              />
              <PunchList
                worker={selectedWorker}
                weekStartDate={startDate}
                allWorkers={allWorkers}
                selectedTeam={selectedTeam}
              />
            </>
          )} */}
          {/* </Grid> */}
          {/* <Grid item xs={12} sm={1}></Grid> */}
        </main>
      </div>
    </>
  );

  // const reviewMarkup = (
  //   <>
  //     <div className={classes.root}>
  //       {/* <CssBaseline /> */}
  //       <Drawer
  //         variant="permanent"
  //         className={clsx(classes.drawer, {
  //           [classes.drawerOpen]: dscDrawerOpen,
  //           [classes.drawerClose]: !dscDrawerOpen,
  //         })}
  //         classes={{
  //           paper: clsx({
  //             [classes.drawerOpen]: dscDrawerOpen,
  //             [classes.drawerClose]: !dscDrawerOpen,
  //           }),
  //         }}
  //         PaperProps={{ className: classes.paperStyle }}
  //       >
  //         <Reportees
  //           allWorkers={allWorkers}
  //           allPunches={allPunches}
  //           allOtherPunches={allOtherPunches}
  //           selectedWorker={selectedWorker}
  //           setSelectedWorker={setSelectedWorker}
  //           isManageWorkers={isManageWorkers}
  //           setManageWorkers={setManageWorkers}
  //           isReportView={isReportView}
  //           setReportView={setReportView}
  //           approveForManager={selectedManagerForApproval}
  //           selectedTeam={selectedTeam}
  //           setSelectedTeam={setSelectedTeam}
  //           isAllPunchView={isAllPunchView}
  //           setAllPunchView={setAllPunchView}
  //         />
  //         <DrawerFooter/>
  //       </Drawer>
  //       <main className={classes.content}>
  //         {isManageWorkers ? (
  //           <ManageWorkers
  //             allWorkers={allWorkers}
  //             handleEditWorker={handleEditWorker}
  //             reloadList={reloadList}
  //             selectedTeam={selectedTeam}
  //             approveForManager={selectedManagerForApproval}
  //           />
  //         ) : isReportView ? (
  //           <>
  //             <ReportHeader dateHandles={[month, setMonth]} />
  //             <ReportView month={month} />
  //           </>
  //         ) : isAllPunchView ? (
  //           <>
  //             <PunchHeader
  //               dateHandles={[startDate, setStartDate]}
  //               worker={selectedWorker}
  //               workers={allWorkers[selectedTeam]}
  //               isAllPunchView={isAllPunchView}
  //             />
  //             <AllPunchView
  //               weekStartDate={startDate}
  //               allWorkers={allWorkers}
  //               selectedTeam={selectedTeam}
  //             />
  //           </>
  //         ) : (
  //           <>
  //             <PunchHeader
  //               dateHandles={[startDate, setStartDate]}
  //               worker={selectedWorker}
  //               isAllPunchView={isAllPunchView}
  //             />
  //             <PunchList
  //               worker={selectedWorker}
  //               weekStartDate={startDate}
  //               allWorkers={allWorkers}
  //               selectedTeam={selectedTeam}
  //             />
  //           </>
  //         )}
  //         {/* </Grid> */}
  //         {/* <Grid item xs={12} sm={1}></Grid> */}
  //       </main>
  //     </div>
  //   </>
  // );

  // return <>{reviewMarkup}</>;
  return (
    <>
      {userLoading ? (
        <>
          <CircularProgress />
          <Typography variant="body2">
            {t("pgReview.loadingGoogleUserDetails")}
          </Typography>
        </>
      ) : loadingError ? (
        // <Typography variant="body2" color="error">
        //   {t(loadingError)}
        // </Typography>
        <Alert severity="info">{t(loadingError)}</Alert>
      ) : (
        reviewMarkup
      )}
    </>
  );
};

const drawerWidth = 270;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    overflow: "auto",
  },
  paperStyle: {
    top: "unset",
    height: `calc(100% - 100px)`,
    border: "none",
  },
}));

ReviewView.propTypes = {};

export default ReviewView;
